/* eslint no-undef: "error" */
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import { SHOW_MODAL } from '@/store/action.types'

export default {
  data () {
    return {
      removeGmbModal: {show: false},
      isGMBLoading: true,
      isFacebookReviewsLoading: true,
      gmbSetup: {},
      gmbDistributionValue: 0,
      fbReviewsSetup: {}
    }
  },
  computed: {
    ...mapState({
      modalPopup: state => state.app.modal
    }),
    isGoogleConnected () {
      return ('data' in this.gmbSetup) && this.gmbSetup.data
    },
    isFacebookReviewsConnected () {
      return ('data' in this.fbReviewsSetup) && this.fbReviewsSetup.data
    }
  },
  created () {
    window.events.$on('removeGMBSetup', this.removeGMBSetup)
  },
  destroyed () {
    window.events.$off('removeGMBSetup')
  },
  methods: {
    ...mapActions({
      showModal: `app/${SHOW_MODAL}`
    }),
    removeAccountConfirmation () {
      this.showModal()
      this.removeGmbModal.show = true
    },
    checkGMBSetup () {
      this.isGMBLoading = true
      const isFreeSub = () => {
        if (window.localStorage.getItem('billingDetails')) {
          return (JSON.parse(window.localStorage.getItem('billingDetails')).subscription.name).toLowerCase() === 'free'
        }
        return false
      }

      if (!isFreeSub()) {
        const prom = axios.get(`/social/gmb/check-gmb-setup/${this.businessSlug}`)
        prom.then(({data}) => {
          this.gmbSetup = data.data
          if (this.gmbSetup.data !== undefined && this.gmbSetup.data !== null && this.gmbSetup.data.distribution !== undefined) {
            this.gmbDistributionValue = this.gmbSetup.data.distribution
          }
          this.isGMBLoading = false

          if (!this.isGoogleConnected && ('id' in this.gmbSetup) && this.$route.query.googleSetup === 'true') {
            this.openGmb('locationSetup')
          }
        })
          .catch(() => {
            this.gmbSetup = {}
            this.isGMBLoading = false
          })
        return prom
      } else {
        return new Promise((resolve) => {
          this.gmbSetup = {}
          this.isGMBLoading = false
          resolve()
        })
      }
    },
    removeGMBSetup () {
      this.showModal(false)
      this.removeGmbModal.show = false
      axios.delete(`/social/gmb/remove-gmb-setup/${this.businessSlug}`)
      .then(({data}) => {
        this.displaySuccessMsg(`Your Google account has been successfully removed!`, 'Removed the Google My Business account.')
        this.checkGMBSetup()
      })
      .catch(() => {
        this.checkGMBSetup()
      })
    },
    checkFacebookReviewsSetup () {
      this.isFacebookReviewsLoading = true
      const isFreeSub = () => {
        if (window.localStorage.getItem('billingDetails')) {
          return (JSON.parse(window.localStorage.getItem('billingDetails')).subscription.name).toLowerCase() === 'free'
        }
        return false
      }

      if (!isFreeSub()) {
        const prom = axios.get(`/social/fb/check-facebook-reviews-setup/${this.businessSlug}`)
        prom.then(({data}) => {
          this.fbReviewsSetup = data.data
          this.isFacebookReviewsLoading = false

          // if (!this.isGoogleConnected && ('id' in this.gmbSetup) && this.$route.query.googleSetup === 'true') {
          //   this.openGmb('locationSetup')
          // }
        })
          .catch(() => {
            this.fbReviewsSetup = {}
            this.isFacebookReviewsLoading = false
          })
        return prom
      } else {
        return new Promise((resolve) => {
          this.isFacebookReviewsLoading = false
          resolve()
        })
      }
    },
    completeFacebookPageSelectSetup () {
      console.log('facebook page selected')
    },
    removeFacebookReviewsSetup () {
      this.showModal(false)
      this.removeGmbModal.show = false
      axios.delete(`/social/fb/remove-setup/${this.businessSlug}`)
        .then(({data}) => {
          this.displaySuccessMsg(`Your Facebook Reviews account has been successfully removed!`, 'Removed the Facebook Reviews account.')
          this.checkFacebookReviewsSetup()
          window.location.href = '/reviews'
        })
        .catch(() => {
          this.checkFacebookReviewsSetup()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/gmb.js